import { useTranslation } from 'react-i18next'
import { cn } from '@/lib/utils'

/* Marca em texto (sem logo de tenant neste app): icone do app + "ChildFund Brasil · Organizacoes parceiras". */
export function Wordmark({ inverse = false, className }: { inverse?: boolean; className?: string }) {
    const { t } = useTranslation()
    return (
        <span className={cn('flex items-center gap-2.5', className)}>
            <img src="/icons/android-chrome-192x192.png" alt="" aria-hidden="true" className="size-9 shrink-0 rounded-xl bg-white" />
            <span className="flex flex-col leading-tight">
                <span className={cn('font-display text-base font-bold', inverse ? 'text-white' : 'text-brand-strong')}>{t('common.brand')}</span>
                <span className={cn('text-[0.72rem] font-semibold', inverse ? 'text-white/85' : 'text-ink-muted')}>{t('common.brandSub')}</span>
            </span>
        </span>
    )
}
